import WebApp from "@twa-dev/sdk";

export const safeOpenTelegramLink = (url) => {
  if (!url) return;
  // Clean up quotes and trim
  let cleanUrl = url.replace(/"/g, '').trim();
  // Replace legacy telegram.me domain with t.me for strict WebApp regex
  cleanUrl = cleanUrl.replace("telegram.me", "t.me");

  try {
    WebApp.openTelegramLink(cleanUrl);
  } catch (err) {
    console.error("openTelegramLink failed, falling back to openLink:", err);
    try {
      WebApp.openLink(cleanUrl);
    } catch (e) {
      window.open(cleanUrl, "_blank");
    }
  }
};
